import { intrinsicClassName } from '../../../utils/reactView';
import styles from './Col.module.css';

export const Col = intrinsicClassName('div', styles.col);
